class MenuDrawer extends HTMLElement {
    constructor() {
      super();
  
      this.storageKey = 'theme:menu-drawer-open';
  
      this.openButtons = document.querySelectorAll(
        '[aria-controls="' + this.id + '"]'
      );
  
      this.closeButtons = document.querySelectorAll(
        '.close-menu_drawer, .menu-drawer-overlay[aria-controls="' + this.id + '"]'
      );
  
      this.onOpenClick = this.onOpenClick.bind(this);
      this.onCloseClick = this.onCloseClick.bind(this);
      this.onKeyDown = this.onKeyDown.bind(this);
      this.onSubmenuClick = this.onSubmenuClick.bind(this);
    }
  
    connectedCallback() {
      if (this.dataset.menuDrawerInit === 'true') return;
  
      this.dataset.menuDrawerInit = 'true';
  
      this.openButtons.forEach((button) => {
        if (button.classList.contains('fixed-overlay')) return;
  
        button.addEventListener('click', this.onOpenClick);
      });
  
      this.closeButtons.forEach((button) => {
        button.addEventListener('click', this.onCloseClick);
      });
  
      this.initSubmenus();
  
      if (
        window.Shopify &&
        Shopify.designMode &&
        sessionStorage.getItem(this.storageKey) === 'true'
      ) {
        requestAnimationFrame(() => {
          this.openDrawer();
        });
      }
    }
  
    disconnectedCallback() {
      this.openButtons.forEach((button) => {
        button.removeEventListener('click', this.onOpenClick);
      });
  
      this.closeButtons.forEach((button) => {
        button.removeEventListener('click', this.onCloseClick);
      });
  
      document.removeEventListener('keydown', this.onKeyDown);
    }
  
    onOpenClick(event) {
      event.preventDefault();
  
      this.openDrawer();
    }
  
    onCloseClick(event) {
      event.preventDefault();
  
      this.closeDrawer();
    }
  
    openDrawer() {
      this.classList.add('open');
      this.setAttribute('open', '');
  
      document.documentElement.classList.add('menu-drawer-open');
      document.body.classList.add('menu-drawer-open');
  
      this.openButtons.forEach((button) => {
        button.setAttribute('aria-expanded', 'true');
      });
  
      if (window.Shopify && Shopify.designMode) {
        sessionStorage.setItem(this.storageKey, 'true');
      }
  
      document.addEventListener('keydown', this.onKeyDown);
    }
  
    closeDrawer() {
      this.classList.remove('open');
      this.removeAttribute('open');
  
      document.documentElement.classList.remove('menu-drawer-open');
      document.body.classList.remove('menu-drawer-open');
  
      this.openButtons.forEach((button) => {
        button.setAttribute('aria-expanded', 'false');
      });
  
      if (window.Shopify && Shopify.designMode) {
        sessionStorage.removeItem(this.storageKey);
      }
  
      document.removeEventListener('keydown', this.onKeyDown);
  
      this.closeAllSubmenus();
    }
  
    onKeyDown(event) {
      if (event.key === 'Escape') {
        this.closeDrawer();
      }
    }
  
    initSubmenus() {
      this.querySelectorAll('[data-menu-collapse]').forEach((toggle) => {
        toggle.removeEventListener('click', this.onSubmenuClick);
        toggle.addEventListener('click', this.onSubmenuClick);
  
        const target = this.getCollapseTarget(toggle);
  
        toggle.setAttribute('aria-expanded', 'false');
        toggle.classList.add('collapsed');
  
        if (!target) return;
  
        target.hidden = true;
        target.classList.remove('show');
        target.style.height = '0px';
        target.style.overflow = 'hidden';
      });
    }
  
    onSubmenuClick(event) {
      event.preventDefault();
  
      const toggle = event.currentTarget;
      const target = this.getCollapseTarget(toggle);
  
      if (!target) return;
  
      if (target.classList.contains('show')) {
        this.closeSubmenu(toggle, target);
      } else {
        this.openSubmenu(toggle, target);
      }
    }
  
    getCollapseTarget(toggle) {
      const controls = toggle.getAttribute('aria-controls');
      const href = toggle.getAttribute('href');
  
      let id = controls;
  
      if (!id && href && href.startsWith('#')) {
        id = href.replace('#', '');
      }
  
      if (!id) return null;
  
      return this.querySelector('#' + CSS.escape(id));
    }
  
    openSubmenu(toggle, target) {
      target.hidden = false;
      target.classList.add('show');
  
      toggle.classList.remove('collapsed');
      toggle.classList.add('active');
      toggle.setAttribute('aria-expanded', 'true');
  
      target.style.height = '0px';
      target.style.overflow = 'hidden';
  
      requestAnimationFrame(() => {
        target.style.transition = 'height 0.25s ease';
        target.style.height = target.scrollHeight + 'px';
      });
  
      target.addEventListener(
        'transitionend',
        () => {
          if (!target.classList.contains('show')) return;
  
          target.style.height = 'auto';
          target.style.overflow = 'visible';
          target.style.transition = '';
        },
        { once: true }
      );
    }
  
    closeSubmenu(toggle, target) {
      target.style.height = target.scrollHeight + 'px';
      target.style.overflow = 'hidden';
  
      requestAnimationFrame(() => {
        target.style.transition = 'height 0.25s ease';
        target.style.height = '0px';
      });
  
      toggle.classList.add('collapsed');
      toggle.classList.remove('active');
      toggle.setAttribute('aria-expanded', 'false');
  
      target.addEventListener(
        'transitionend',
        () => {
          target.classList.remove('show');
          target.hidden = true;
          target.style.transition = '';
        },
        { once: true }
      );
  
      this.closeChildrenSubmenus(target);
    }
  
    closeChildrenSubmenus(parent) {
      parent.querySelectorAll('[data-menu-collapse]').forEach((toggle) => {
        const target = this.getCollapseTarget(toggle);
  
        toggle.classList.add('collapsed');
        toggle.classList.remove('active');
        toggle.setAttribute('aria-expanded', 'false');
  
        if (!target) return;
  
        target.classList.remove('show');
        target.hidden = true;
        target.style.height = '0px';
        target.style.overflow = 'hidden';
        target.style.transition = '';
      });
    }
  
    closeAllSubmenus() {
      this.querySelectorAll('[data-menu-collapse]').forEach((toggle) => {
        const target = this.getCollapseTarget(toggle);
  
        toggle.classList.add('collapsed');
        toggle.classList.remove('active');
        toggle.setAttribute('aria-expanded', 'false');
  
        if (!target) return;
  
        target.classList.remove('show');
        target.hidden = true;
        target.style.height = '0px';
        target.style.overflow = 'hidden';
        target.style.transition = '';
      });
    }
  }
  
  if (!customElements.get('menu-drawer')) {
    customElements.define('menu-drawer', MenuDrawer);
  }
  
  document.addEventListener('shopify:section:load', (event) => {
    const menuDrawer = event.target.querySelector('menu-drawer');
  
    if (!menuDrawer) return;
  
    if (
      window.Shopify &&
      Shopify.designMode &&
      sessionStorage.getItem('theme:menu-drawer-open') === 'true'
    ) {
      requestAnimationFrame(() => {
        if (typeof menuDrawer.openDrawer === 'function') {
          menuDrawer.openDrawer();
        }
      });
    }
  });